import { render, staticRenderFns } from "./MasterdataModal.vue?vue&type=template&id=6f52a73f"
import script from "./MasterdataModal.vue?vue&type=script&lang=js"
export * from "./MasterdataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports